<template>
  <div>
    <div class="loader" v-if="isLoading"></div>
    <div class="loadertext" v-if="isLoading">
      {{ $t("loadingTxt") }}...
    </div>

    <div class="main-wrapper" :class="{ 'blur-content': isLoading }" ref="formElement">
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <!-- Back -->
          <div class="mb-3">
            <button class="btn btn-link px-0 text-decoration-none" @click="goBack">
              <i class="mdi mdi-arrow-left me-1"></i>
              Back to File History
            </button>
          </div>

          <!-- Header Form Card -->
          <div class="card mb-3">
            <div class="card-body">
              <!-- Customer Name -->
              <div class="row mb-2 mt-3 align-items-center">
                <label class="col-sm-2 col-form-label fw-semibold">Customer</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control" :value="customerName" disabled />
                </div>
                <!-- <div class="col-sm-6 d-flex justify-content-end">
                  <span class="fw-semibold me-2">Update All</span>
                </div> -->
              </div>

              <div class="row">
                <!-- LEFT COLUMN -->
                <div class="col-lg-6">
                  <!-- Periode Awal -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Periode Awal</label>
                    <div class="col-sm-6">
                      <Datepicker
                        v-model="headerForm.periode_start"
                        :bootstrap-styling="true"
                        format="yyyy-MM-dd"
                        :disabled="isView"
                        placeholder="YYYY-MM-DD"
                        input-class="form-control bg-white"
                        @selected="onPeriodeChange"
                      ></Datepicker>
                    </div>
                    <div class="col-sm-2 d-flex flex-column align-items-center justify-content-center">
                      <span class="fw-semibold text-muted mb-1" style="font-size: 0.75rem; line-height: 1;">Update All</span>
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="updateAllFlags.periode_start"
                        :disabled="isView"
                        title="Update All"
                      />
                    </div>
                  </div>

                  <!-- Periode Akhir -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Periode Akhir</label>
                    <div class="col-sm-6">
                      <Datepicker
                        v-model="headerForm.periode_end"
                        :bootstrap-styling="true"
                        format="yyyy-MM-dd"
                        :disabled="isView"
                        placeholder="YYYY-MM-DD"
                        input-class="form-control bg-white"
                        @selected="onPeriodeChange"
                      ></Datepicker>
                    </div>
                    <div class="col-sm-2 d-flex align-items-center justify-content-center">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="updateAllFlags.periode_end"
                        :disabled="isView"
                        title="Update All"
                      />
                    </div>
                  </div>

                  <!-- Utilisasi (readonly) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Utilisasi</label>
                    <div class="col-sm-6">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :value="utilisasi"
                          disabled
                        />
                        <span class="input-group-text">Hari</span>
                      </div>
                    </div>
                  </div>

                  <!-- Rate -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Rate</label>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="headerForm.rate"
                        readonly
                        min="0"
                      />
                    </div>
                  </div>

                  <!-- Pemakai -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Pemakai</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="headerForm.pemakai"
                        :disabled="isView"
                        placeholder="Pemakai"
                      />
                    </div>
                  </div>

                  <!-- Report Period (readonly) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Report Period</label>
                    <div class="col-sm-6">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :value="reportPeriodDisplay"
                          disabled
                        />
                        <span class="input-group-text">
                          <i class="mdi mdi-calendar"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Contract Due Date (disabled) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Contract Due Date</label>
                    <div class="col-sm-6">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :value="contractPeriodDisplay"
                          disabled
                        />
                        <span class="input-group-text">
                          <i class="mdi mdi-calendar"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- RIGHT COLUMN -->
                <div class="col-lg-6">
                  <!-- No Polisi -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Vehicle No</label>
                    <div class="col-sm-8">
                      <multiselect
                        v-model="headerForm.selectedNopol"
                        :options="nopolOptions"
                        track-by="id"
                        label="no_polisi"
                        placeholder="Cari Vehicle No..."
                        :searchable="true"
                        :loading="isSearchingNopol"
                        @search-change="searchNopol"
                        :show-labels="false"
                        :disabled="isView || isEditingDetail"
                      >
                        <span slot="noResult">Tidak ditemukan</span>
                      </multiselect>
                    </div>
                  </div>

                  <!-- Merk Unit (auto-fill) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Merk Unit</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        :value="selectedNopolData.merk || ''"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- Tipe Truk (auto-fill) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Tipe Truk</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        :value="selectedNopolData.tipe_truk || ''"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- Tahun (auto-fill) -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Tahun</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        :value="selectedNopolData.tahun || ''"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- Un-Utilize -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">Un-utilize</label>
                    <div class="col-sm-5">
                      <div class="input-group">
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="headerForm.un_utilize"
                          :disabled="isView"
                          min="0"
                        />
                        <span class="input-group-text">Hari</span>
                      </div>
                    </div>
                  </div>

                  <!-- No Invoice -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">No Invoice</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="headerForm.no_invoice"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- No FP -->
                  <div class="row mb-2 align-items-center">
                    <label class="col-sm-4 col-form-label">No FP</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        v-model.trim="headerForm.no_fp"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- Reset Button -->
                  <div class="row mb-2">
                    <div class="col-sm-12 d-flex justify-content-end">
                      <button
                        class="btn btn-danger"
                        @click="resetForm"
                        :disabled="isView"
                        type="button"
                      >
                        <i class="mdi mdi-refresh me-1"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Simpan Edit / Tambah buttons -->
              <div class="d-flex justify-content-end gap-2 mt-2" v-if="!isView">
                <button
                  class="btn btn-warning text-dark fw-semibold"
                  @click="saveEdit"
                  :disabled="!isEditingDetail || isSaving"
                >
                  <span v-if="isSaving">
                    <i class="mdi mdi-loading mdi-spin me-1"></i> Menyimpan...
                  </span>
                  <span v-else>
                    <i class="mdi mdi-content-save-edit-outline me-1"></i> Simpan Edit
                  </span>
                </button>
                <button
                  class="btn btn-success"
                  @click="addNopol"
                  :disabled="isEditingDetail || !headerForm.selectedNopol || isLoading"
                >
                  <i class="mdi mdi-plus me-1"></i> Tambah
                </button>
              </div>
            </div>
          </div>

          <!-- Detail Table Card -->
          <div class="card">
            <div class="card-body">
              <vue-good-table
                ref="detailTable"
                :columns="detailColumns"
                :rows="detailRows"
                :select-options="{
                  enabled: !isView,
                  selectOnCheckboxOnly: true,
                  selectionText: $t('data_selected'),
                  clearSelectionText: $t('clear'),
                }"
                styleClass="vgt-table striped bordered"
              >
                <template slot="table-row" slot-scope="props">
                  <!-- Action column -->
                  <span v-if="props.column.field === 'actions'">
                    <div class="d-flex gap-1" v-if="!isView && docStatus !== 'PRINTED'">
                      <!-- Delete -->
                      <button
                        type="button"
                        class="btn btn-icon btn-sm btn-outline-danger"
                        @click="deleteDetail(props.row, props.row.originalIndex !== undefined ? props.row.originalIndex : props.index)"
                        title="Delete"
                        :disabled="isEditingDetail && editingDetailIndex !== (props.row.originalIndex !== undefined ? props.row.originalIndex : props.index)"
                      >
                        <i class="mdi mdi-trash-can-outline"></i>
                      </button>
                      <!-- Edit -->
                      <button
                        type="button"
                        class="btn btn-icon btn-sm btn-outline-primary"
                        @click="startEditDetail(props.row, props.row.originalIndex !== undefined ? props.row.originalIndex : props.index)"
                        title="Edit"
                        :disabled="isEditingDetail && editingDetailIndex !== (props.row.originalIndex !== undefined ? props.row.originalIndex : props.index)"
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </button>
                    </div>
                  </span>

                  <!-- Total Sewa formatted -->
                  <span v-else-if="props.column.field === 'total_sewa'">
                    {{ formatCurrency(props.row.total_sewa) }}
                  </span>

                  <!-- Utilisasi hari -->
                  <span v-else-if="props.column.field === 'utilisasi'">
                    {{ props.row.utilisasi }}
                  </span>

                  <span v-else>
                    {{ props.formattedRow[props.column.field] || "-" }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>

          <!-- Kirim Data Button -->
          <div class="d-flex justify-content-end mt-3" v-if="!isView">
            <button
              class="btn btn-info text-white fw-semibold"
              @click="sendData"
              :disabled="isSending"
            >
              <span v-if="isSending">
                <i class="mdi mdi-loading mdi-spin me-1"></i> Mengirim...
              </span>
              <span v-else>
                <i class="mdi mdi-send me-1"></i> Kirim data
              </span>
            </button>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

export default {
  name: "ProformaRentalForm",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isSending: false,
      isSearchingNopol: false,
      isEditingDetail: false,
      editingDetailIndex: null,
      editingDetailId: null,

      permision_role: {
        method_create: true,
        method_read: true,
        method_update: true,
        method_delete: true,
      },

      // Context from route
      // proforma_rental_company_id = route param customerId (e.g. 3)
      // company_id = route query (e.g. 745) — dipakai di body generate
      customer: {
        proforma_rental_company_id: this.$route.params.customerId,
        company_id: this.$route.query.company_id || null,
        company_name: this.$route.query.company_name || "-",
        company_code: this.$route.query.company_code || "-",
        sap_code: this.$route.query.sap_code || "-",
      },
      // reportId di sini = proforma_rental_header_id (dari row.id di history)
      reportId: this.$route.params.reportId,
      reportName: this.$route.query.report_name || "-",
      docStatus: this.$route.query.status || "DRAFT",

      // Header form fields
      headerForm: {
        selectedNopol: null,
        periode_start: "",
        periode_end: "",
        rate: 0,
        pemakai: "",
        un_utilize: 0,
        no_invoice: "",
        no_fp: "",
        report_period: "",
        contract_period: "",
      },

      // Update All checkboxes
      updateAllFlags: {
        periode_start: false,
        periode_end: false,
      },

      // Nopol search options
      nopolOptions: [],

      // Detail list
      detailRows: [],
    };
  },
  computed: {
    isView() {
      return this.$route.name === "ProformaRentalView" || this.docStatus === "PRINTED";
    },
    customerName() {
      return this.customer.company_name;
    },
    reportPeriodDisplay() {
      if (!this.headerForm.report_period) return "-";
      // Format: "januari/2026" style
      const d = this.$moment(this.headerForm.report_period);
      return d.isValid() ? d.format("MMMM/YYYY") : this.headerForm.report_period;
    },
    contractPeriodDisplay() {
      const val = this.headerForm.contract_period || this.headerForm.contract_duedate;
      if (!val) return "-";
      const d = this.$moment(val);
      return d.isValid() ? d.format("DD-MMM-YYYY") : val;
    },
    // Utilisasi = Periode Akhir - Periode Awal (days)
    utilisasi() {
      if (!this.headerForm.periode_start || !this.headerForm.periode_end) return 0;
      const start = this.$moment(this.headerForm.periode_start);
      const end = this.$moment(this.headerForm.periode_end);
      if (!start.isValid() || !end.isValid()) return 0;
      return end.diff(start, "days") + 1; // inclusive
    },
    selectedNopolData() {
      if (!this.headerForm.selectedNopol) return {};
      return {
        merk: this.headerForm.selectedNopol.merk || "",
        tipe_truk: this.headerForm.selectedNopol.tipe_truk || "",
        tahun: this.headerForm.selectedNopol.tahun || "",
      };
    },
    proformaInvoiceEndpoint() {
      return String(this.$settings?.endPointProformaInvoice || "").replace(/\/?$/, "/");
    },
    detailColumns() {
      const cols = [];

      // Action column (hidden on PRINTED or View)
      if (!this.isView && this.docStatus !== "PRINTED") {
        cols.push({ label: "Action", field: "actions", sortable: false, width: "90px" });
      }

      cols.push(
        { label: "Pemakai", field: "pemakai" },
        { label: "No Polisi", field: "no_polisi" },
        { label: "Merk", field: "merk" },
        { label: "Type", field: "tipe_truk" },
        { label: "Year", field: "tahun" },
        { label: "Per Awal", field: "periode_start" },
        { label: "Per Akhir", field: "periode_end" },
        { label: "Utilisasi", field: "utilisasi" },
        { label: "Un-Utilize", field: "un_utilize" },
        { label: "Total Sewa", field: "total_sewa" }
      );

      return cols;
    },
  },
  watch: {
    // When Update All checkboxes are toggled, apply to all rows
    "updateAllFlags.periode_start"(val) {
      if (val && this.headerForm.periode_start) this.applyUpdateAll("periode_start", this.headerForm.periode_start);
    },
    "updateAllFlags.periode_end"(val) {
      if (val && this.headerForm.periode_end) this.applyUpdateAll("periode_end", this.headerForm.periode_end);
    },
  },
  methods: {
    // ── Navigation ────────────────────────────────────────────────────────────
    goBack() {
      this.$router.push({
        name: "ProformaRentalHistory",
        params: { customerId: this.customer.proforma_rental_company_id },
        query: {
          company_name: this.customer.company_name,
          company_code: this.customer.company_code,
          sap_code: this.customer.sap_code,
          company_id: this.customer.company_id,
        },
      });
    },

    // ── Load Data ─────────────────────────────────────────────────────────────
    async loadDetail() {
      if (!this.reportId) return;
      this.isLoading = true;
      try {
        // GET v1/proforma-rental-header/header-detail/{proforma_rental_header_id}
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/proforma-rental-header/header-detail/${this.reportId}`
        );
        const header = response.data?.datas || response.data?.data || response.data || {};

        // Fill header form from response datas
        this.headerForm.no_invoice = header.inv_no || header.no_invoice || "";
        this.headerForm.no_fp = header.fp_no || header.no_fp || "";
        this.headerForm.report_period = (header.report_period && header.report_period !== "0000-00-00") ? header.report_period : "";
        this.headerForm.contract_period = header.contract_period || header.contract_duedate || "";
        this.headerForm.rate = Number(header.rate || 0);
        this.headerForm.pemakai = header.pemakai || "";
        this.headerForm.periode_start = header.periode_start ? this.$moment(header.periode_start).format("YYYY-MM-DD") : "";
        this.headerForm.periode_end = header.periode_end ? this.$moment(header.periode_end).format("YYYY-MM-DD") : "";
        this.docStatus = String(header.status || this.docStatus).toUpperCase();

        // Details table array from response datas.details
        const details = Array.isArray(header.details) ? header.details : (Array.isArray(header.detail) ? header.detail : []);
        
        // Auto-fill header form fields from first detail row if header fields are empty
        if (details.length > 0) {
          const first = details[0];
          if (!this.headerForm.periode_start && first.periode_start) {
            this.headerForm.periode_start = this.$moment(first.periode_start).format("YYYY-MM-DD");
          }
          if (!this.headerForm.periode_end && first.periode_end) {
            this.headerForm.periode_end = this.$moment(first.periode_end).format("YYYY-MM-DD");
          }
          if (!this.headerForm.pemakai && first.pemakai) {
            this.headerForm.pemakai = first.pemakai;
          }
        }

        this.detailRows = details.map((item) => this.mapDetailRow(item));

        // Initial load for vehicle no options
        this.searchNopol("");
      } catch (error) {
        this.handleRequestError(error, "Gagal load detail report.");
      } finally {
        this.isLoading = false;
      }
    },

    mapDetailRow(item) {
      const start = this.$moment(item.periode_start);
      const end = this.$moment(item.periode_end);
      const utilisasi = (start.isValid() && end.isValid()) ? end.diff(start, "days") + 1 : (item.utilized ?? item.utilisasi ?? 0);
      const un_utilize = Number(item.unutilized ?? item.un_utilize ?? 0);
      const rate = Number(item.rate ?? this.headerForm.rate ?? 0);
      const totalSewa = (item.total_sewa != null && item.total_sewa !== "")
        ? Number(item.total_sewa)
        : this.calcTotalSewa(rate, utilisasi, un_utilize, item.is_prorate);

      return {
        id              : item.proforma_rental_detail_id || item.id,
        pemakai         : item.pemakai || "-",
        no_polisi       : item.vehicle_no || item.no_polisi || "-",
        merk            : item.truck_brand || item.merk || "-",
        tipe_truk       : item.type_truck || item.tipe_truk || item.type || "-",
        tahun           : item.manufacture_year || item.tahun || item.year || "-",
        master_truck_id : item.master_truck_id || null,
        periode_start   : item.periode_start ? this.$moment(item.periode_start).format("YYYY-MM-DD") : "",
        periode_end     : item.periode_end ? this.$moment(item.periode_end).format("YYYY-MM-DD") : "",
        utilisasi,
        un_utilize,
        rate,
        is_prorate      : !!item.is_prorate,
        total_sewa      : totalSewa,
        raw             : item,
      };
    },

    // ── Kalkulasi ──────────────────────────────────────────────────────────────
    /**
     * Pro-rate Total Sewa = (Rate ÷ Utilisasi) × (Utilisasi − Un-utilize)
     * Non pro-rate Total Sewa = Rate
     */
    calcTotalSewa(rate, utilisasi, unUtilize, isProrate) {
      if (isProrate && utilisasi > 0) {
        return (rate / utilisasi) * (utilisasi - unUtilize);
      }
      return rate;
    },

    recalcAllTotalSewa() {
      this.detailRows = this.detailRows.map((row) => ({
        ...row,
        total_sewa: this.calcTotalSewa(row.rate, row.utilisasi, row.un_utilize, row.is_prorate),
      }));
    },

    onPeriodeChange() {
      // If Update All flag is checked, apply to all rows
      if (this.updateAllFlags.periode_start && this.headerForm.periode_start) {
        this.applyUpdateAll("periode_start", this.headerForm.periode_start);
      }
      if (this.updateAllFlags.periode_end && this.headerForm.periode_end) {
        this.applyUpdateAll("periode_end", this.headerForm.periode_end);
      }
    },

    handleUpdateAll() {
      if (this.headerForm.periode_start) {
        this.applyUpdateAll("periode_start", this.headerForm.periode_start);
      }
      if (this.headerForm.periode_end) {
        this.applyUpdateAll("periode_end", this.headerForm.periode_end);
      }
    },

    applyUpdateAll(field, value) {
      this.detailRows = this.detailRows.map((row) => {
        const updated = { ...row, [field]: value };

        // Recalc utilisasi if periode changes
        if (field === "periode_start" || field === "periode_end") {
          const start = this.$moment(updated.periode_start);
          const end = this.$moment(updated.periode_end);
          updated.utilisasi = (start.isValid() && end.isValid()) ? end.diff(start, "days") + 1 : 0;
          updated.total_sewa = this.calcTotalSewa(updated.rate, updated.utilisasi, updated.un_utilize, updated.is_prorate);
        }

        // Recalc if rate changes
        if (field === "rate") {
          updated.total_sewa = this.calcTotalSewa(updated.rate, updated.utilisasi, updated.un_utilize, updated.is_prorate);
        }

        return updated;
      });
    },

    // ── Nopol Search ──────────────────────────────────────────────────────────
    async searchNopol(query) {
      this.isSearchingNopol = true;
      try {
        const q = query ? String(query).trim() : "";
        const baseURI = `${this.$settings.endPointCt}master-truck/select?limit=20&vehicle_no=${q}`;
        const response = await this.$http.get(baseURI);
        this.nopolOptions = (response.data?.datas?.data || []).map((item) => ({
          id: item.id || item.master_truck_id,
          no_polisi: item.vehicle_no || item.no_polisi,
          merk: item.brand || item.truck_brand || item.merk || "",
          tipe_truk: item.type_truck || item.tipe_truk || item.type || "",
          tahun: item.manufacture_year || item.tahun || item.year || "",
        }));
      } catch {
        this.nopolOptions = [];
      } finally {
        this.isSearchingNopol = false;
      }
    },

    // ── Tambah Nopol ──────────────────────────────────────────────────────────
    addNopol() {
      if (!this.headerForm.selectedNopol) {
        this.showError("Pilih No Polisi terlebih dahulu.");
        return;
      }

      // Validasi duplikat berdasarkan no_polisi / vehicle_no
      const isDuplicate = this.detailRows.some(
        (row) => row.no_polisi === this.headerForm.selectedNopol.no_polisi
      );
      if (isDuplicate) {
        this.showError(`No Polisi ${this.headerForm.selectedNopol.no_polisi} sudah terdaftar.`);
        return;
      }

      const utilisasi = this.utilisasi;
      const un_utilize = Number(this.headerForm.un_utilize || 0);
      const rate = Number(this.headerForm.rate || 0);
      const is_prorate = false;

      const newRow = {
        id: null,
        pemakai: this.headerForm.pemakai || "-",
        no_polisi: this.headerForm.selectedNopol.no_polisi,
        merk: this.headerForm.selectedNopol.merk,
        tipe_truk: this.headerForm.selectedNopol.tipe_truk,
        tahun: this.headerForm.selectedNopol.tahun,
        master_truck_id: this.headerForm.selectedNopol.id,
        periode_start: this.headerForm.periode_start ? this.$moment(this.headerForm.periode_start).format("YYYY-MM-DD") : "",
        periode_end: this.headerForm.periode_end ? this.$moment(this.headerForm.periode_end).format("YYYY-MM-DD") : "",
        utilisasi,
        un_utilize,
        rate,
        is_prorate,
        total_sewa: this.calcTotalSewa(rate, utilisasi, un_utilize, is_prorate),
        no_invoice: this.headerForm.no_invoice,
        no_fp: this.headerForm.no_fp,
      };

      this.detailRows.push(newRow);
      this.showSuccess("Nopol berhasil ditambahkan.");
      this.resetForm();
    },

    // ── Edit Detail ───────────────────────────────────────────────────────────
    startEditDetail(row, index) {
      this.isEditingDetail = true;
      this.editingDetailIndex = index;
      this.editingDetailId = row.id || row.proforma_rental_detail_id;

      // Populate header form with row data
      this.headerForm.selectedNopol = {
        id: row.master_truck_id || row.id,
        no_polisi: row.no_polisi,
        merk: row.merk,
        tipe_truk: row.tipe_truk,
        tahun: row.tahun,
      };
      this.headerForm.pemakai = (row.pemakai && row.pemakai !== "-") ? row.pemakai : "";
      this.headerForm.periode_start = row.periode_start || "";
      this.headerForm.periode_end = row.periode_end || "";
      this.headerForm.rate = Number(row.rate || 0);
      this.headerForm.un_utilize = Number(row.un_utilize || 0);
      this.headerForm.no_invoice = row.no_invoice || "";
      this.headerForm.no_fp = row.no_fp || "";
    },

    saveEdit() {
      if (!this.isEditingDetail || this.editingDetailIndex === null) {
        this.showError("Pilih baris tabel yang ingin di-edit terlebih dahulu.");
        return;
      }

      const utilisasi = this.utilisasi;
      const un_utilize = Number(this.headerForm.un_utilize || 0);
      const rate = Number(this.headerForm.rate || 0);
      const editingRow = this.detailRows[this.editingDetailIndex] || {};
      const is_prorate = editingRow.is_prorate || false;

      const updatedRow = {
        ...editingRow,
        pemakai       : this.headerForm.pemakai || "-",
        periode_start : this.headerForm.periode_start ? this.$moment(this.headerForm.periode_start).format("YYYY-MM-DD") : "",
        periode_end   : this.headerForm.periode_end ? this.$moment(this.headerForm.periode_end).format("YYYY-MM-DD") : "",
        rate,
        un_utilize,
        utilisasi,
        total_sewa    : this.calcTotalSewa(rate, utilisasi, un_utilize, is_prorate),
      };

      this.$set(this.detailRows, this.editingDetailIndex, updatedRow);

      this.showSuccess("Detail berhasil diperbarui.");
      this.resetForm();
    },

    // ── Delete Detail ─────────────────────────────────────────────────────────
    async deleteDetail(row, index) {
      const result = await this.$swal({
        title: this.$t("areYouSure"),
        text: `Nopol ${row.no_polisi} akan dihapus dari detail.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal",
      });

      if (!result.value) return;

      this.detailRows.splice(index, 1);
      this.showSuccess("Detail berhasil dihapus.");
    },

    // ── Reset Form ────────────────────────────────────────────────────────────
    resetForm() {
      this.headerForm.selectedNopol = null;
      this.headerForm.pemakai = "";
      this.headerForm.periode_start = "";
      this.headerForm.periode_end = "";
      this.headerForm.un_utilize = 0;
      this.isEditingDetail = false;
      this.editingDetailIndex = null;
      this.editingDetailId = null;
      // Clear update all flags
      Object.keys(this.updateAllFlags).forEach((k) => {
        this.updateAllFlags[k] = false;
      });
    },

    // ── Kirim Data ────────────────────────────────────────────────────────────
    async sendData() {
      const result = await this.$swal({
        title: "Kirim Data?",
        text: "Data akan dikirim ke sistem.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#17a2b8",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Ya, Kirim",
        cancelButtonText: "Batal",
      });

      if (!result.value) return;

      this.isSending = true;
      try {
        const toDatetime = (d) => {
          if (!d) return null;
          const parsed = this.$moment(d);
          return parsed.isValid() ? `${parsed.format("YYYY-MM-DD")} 00:00:01` : null;
        };

        const toDate = (d) => {
          if (!d) return null;
          const parsed = this.$moment(d);
          return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
        };

        const payload = {
          company_id: Number(this.customer.company_id),
          inv_no: this.headerForm.no_invoice || "",
          report_period: toDate(this.headerForm.report_period) || "",
          rate: Number(this.headerForm.rate || 0),
          periode_start: toDatetime(this.headerForm.periode_start),
          periode_end: toDatetime(this.headerForm.periode_end),
          utilized: String(this.utilisasi || 0),
          periode_start_update_all: this.updateAllFlags.periode_start ? 1 : 0,
          periode_end_update_all: this.updateAllFlags.periode_end ? 1 : 0,
          details: this.detailRows.map((detail) => ({
            master_truck_id: detail.master_truck_id || null,
            vehicle_no: detail.no_polisi || detail.vehicle_no || "",
            truck_brand: detail.merk || detail.truck_brand || "",
            manufacture_year: String(detail.tahun || detail.manufacture_year || ""),
            pemakai: (detail.pemakai && detail.pemakai !== "-") ? detail.pemakai : (this.headerForm.pemakai || ""),
            periode_start: toDatetime(detail.periode_start || this.headerForm.periode_start),
            periode_end: toDatetime(detail.periode_end || this.headerForm.periode_end),
            utilized: String(detail.utilisasi ?? 0),
            unutilized: String(detail.un_utilize ?? detail.unutilized ?? 0),
            periode_start_update_all: this.updateAllFlags.periode_start ? 1 : 0,
            periode_end_update_all: this.updateAllFlags.periode_end ? 1 : 0,
          })),
        };

        await this.$http.post(
          `${this.proformaInvoiceEndpoint}v1/proforma-rental-header/store-header/${this.reportId}`,
          payload
        );
        this.showSuccess("Data berhasil dikirim.");
        this.goBack();
      } catch (error) {
        this.handleRequestError(error, "Gagal mengirim data.");
      } finally {
        this.isSending = false;
      }
    },

    // ── Helpers ───────────────────────────────────────────────────────────────
    formatCurrency(value) {
      const num = Number(value || 0);
      if (!Number.isFinite(num)) return value || "-";
      return num.toLocaleString("id-ID", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    handleRequestError(error, fallbackMessage) {
      if (error?.response?.status === 500) {
        this.$router.push("/server-error");
        return;
      }
      if (error?.response?.status === 404) {
        this.$router.push("/page-not-found");
        return;
      }

      const responseData = error?.response?.data;
      const errorsObj = responseData?.errors;
      const messages = [];

      if (errorsObj && typeof errorsObj === "object") {
        if (typeof errorsObj.message === "string") {
          messages.push(errorsObj.message);
        } else {
          Object.values(errorsObj).forEach((val) => {
            if (Array.isArray(val)) {
              messages.push(...val);
            } else if (typeof val === "string") {
              messages.push(val);
            }
          });
        }
      }

      if (messages.length === 0 && responseData?.message) {
        messages.push(responseData.message);
      }

      if (messages.length > 0) {
        this.$swal({
          icon: "error",
          title: "Gagal Validasi",
          html: `<div style="text-align: left;">${messages.map((m) => `• ${m}`).join("<br>")}</div>`,
          confirmButtonText: "Tutup",
        });
      } else {
        this.showError(fallbackMessage);
      }
    },
    showError(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3500,
      });
      Toast.fire({ icon: "error", title: message });
    },
    showSuccess(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({ icon: "success", title: message });
    },

    // ── Permission ────────────────────────────────────────────────────────────
    fetchIt() {
      const userDatas = this.$getUserInfo ? this.$getUserInfo() : null;
      if (!userDatas?.sub?.permision_role) {
        this.loadDetail();
        return;
      }

      let rolePermision = null;
      userDatas.sub.permision_role.forEach((permision) => {
        if (
          permision.permission.controller === "ProformaInvoiceNstController" ||
          permision.permission.controller === "ProformaRentalHeaderController"
        ) {
          rolePermision = permision;
        }
      });

      if (rolePermision && !rolePermision.method_read) {
        this.$router.push("/authorized-error");
        return;
      }

      if (rolePermision) {
        this.permision_role = rolePermision;
      }

      this.loadDetail();
    },
  },
  mounted() {
    this.fetchIt();

    const formElement = this.$refs.formElement;
    if (formElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "readonly") {
            const inputs = formElement.querySelectorAll(".multiselect__input");
            inputs.forEach((input) => {
              input.removeAttribute("readonly");
            });
          }
        });
      });

      const inputs = formElement.querySelectorAll(".multiselect__input");
      inputs.forEach((input) => {
        input.removeAttribute("readonly");
        observer.observe(input, { attributes: true });
      });
    }
  },
};
</script>

<style scoped>
.form-check-input {
  width: 1.2em;
  height: 1.2em;
  cursor: pointer;
}
</style>
